$(window).on('load', function() {
  "use strict";
  $('.megamenu-li').parent('.container').parent('ul').addClass('mega-menu');
  $('.banner-wrap').parent('.container').parent('ul').addClass('bottom-banner');
  $('.menu-banner').parent('.container').parent('ul').addClass('banner-menu');
  $('.submenu-li').parent('.container').parent('ul').addClass('sub-menu');

  $('.submenu-li').parent('ul').addClass('sub-menu');
  $('.megamenu-li').parent('ul').addClass('mega-menu');
  $('.bannermenu-li').parent('ul').addClass('banner-menu');

  $('.slow-window').fadeOut('slow');

  var popup = localStorage.getItem('popup_value'); 
  if(popup != 1){
    $('#news-letter-modal').modal('show');
  }

  $('#popup-close').on('click',function(){
      localStorage.setItem('popup_value', '1');
  });

  // DW_SIMPLE_MOBILE_NAV: the hamburger toggle, .mobile-menu fixed
  // drawer, its close-box X, and its Bootstrap-Collapse-driven accordion
  // exclusivity (resetMobileMenuState, dwHideCollapsePanel,
  // dwResetLearnSubpanels, and the .main-menu-area / #main-collapse-learn
  // click-delegated exclusivity handlers) were removed here because that
  // entire drawer is now hidden on mobile via CSS
  // (sections/header.liquid, DW_SIMPLE_MOBILE_NAV block) and replaced by
  // a plain in-flow <details>/<summary> nav that needs no JS at all.
  // dwLockBodyScroll/dwUnlockBodyScroll are KEPT below -- they are still
  // used by the cart drawer and filter sidebar, which are untouched.

  var dwScrollLockY = 0;
  function dwLockBodyScroll() {
    dwScrollLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.classList.add('hidden');
    document.body.style.position = 'fixed';
    document.body.style.top = (-dwScrollLockY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function dwUnlockBodyScroll() {
    document.body.classList.remove('hidden');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, dwScrollLockY);
  }

  $(".shopping-cart a.cart-count").on('click', function() {
    $(".mini-cart").addClass("show");
    $(".mm-fullscreen-bg").addClass("active");
    dwLockBodyScroll();
  });

  $(".shopping-cart-close i").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".mm-fullscreen-bg").removeClass("active");
    dwUnlockBodyScroll();
  });

   $(".ajax-spin-cart").on('click', function() {
    window.setTimeout(function() {
      $(".mini-cart").addClass("show");
      $(".mm-fullscreen-bg").addClass("active");
      dwLockBodyScroll();
    }, 1000);
  });

  // filter button js
  $("button.filter-button").on('click', function() {
    $(".filter-sidebar").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
    dwLockBodyScroll();
  });

  $("button.close-filter-sidebar").on('click', function() {
    $(".filter-sidebar").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    dwUnlockBodyScroll();
  });

  // DW_SIMPLE_MOBILE_NAV: this backdrop handler previously also closed
  // .main-menu-area and reset the hamburger's aria-expanded/accordion
  // state. Those lines are removed (dead -- .main-menu-area is hidden
  // and never opened anymore); the mini-cart and filter-sidebar closing
  // logic is kept exactly as before, since .mm-fullscreen-bg is still
  // their shared backdrop.
  $(document).on('click', '.mm-fullscreen-bg', function() {
    $(".mini-cart").removeClass("show");
    $(".mm-fullscreen-bg").removeClass("active");
    $(".filter-sidebar").removeClass("active");
    dwUnlockBodyScroll();
  });

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  });

  $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
    tClose: 'Close (Esc)',
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

      
  $('#top').on('click', function() {
    $("html, body").animate({ scrollTop: 0 }, 0);
    return false;
    });
  });

$(window).scroll(function(){
  if ($(this).scrollTop() > 1000) {
    $('#top').fadeIn();
  } else {
    $('#top').fadeOut();
  }

  var sticky = $('.header-area'),
  scroll = $(window).scrollTop();
  if (scroll >= 150) {
    sticky.addClass('is-sticky');
  }
  else {
    sticky.removeClass('is-sticky');
  }

  $('label.box-area').on('click', function () {
    if($('.cust-checkbox').is(':checked')) {
      $('.agree').removeClass('disabled');
    }
    else {
      $('.agree').addClass('disabled');
    }
  });
  
});
